/* eslint-disable class-methods-use-this */
import React from 'react';
import generalCss from '../../styles/components/checkout-steps/payment/payment-method-selector.scss';

class PaymentMethodTropipay extends React.Component {
    onNext() {
        // add logic here to specify what to do once the Pay With button gets clicked by the user
        console.log('Executing Tropipay Payment');
    }

    selectionToggle() {
        if (this.props.onOptionSelected) {
            this.props.onOptionSelected(this.props.method);
        }
    }

    isThisOptionSelected() {
        return this.props.method && this.props.optionSelected && this.props.method.id === this.props.optionSelected.id;
    }

    shouldNextBeEnabled() {
        // add logic here to specify when next button should be enabled
        return true;
    }

    render() {
        return (
            <div>
                <div>
                    <input
                        type="radio"
                        id={this.props.method.id}
                        name="payment_method"
                        value={this.props.method.name}
                        onChange={() => {
                            this.selectionToggle();
                        }}
                        defaultChecked={this.props.method.isDefault}
                    />
                    <label className={generalCss.pms__option__label} htmlFor={this.props.method.id}>{this.props.method.name}</label>
                </div>
            </div>
        );
    }
}

export default PaymentMethodTropipay;



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/payment/payment-method-tropipay.js
 **/